/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  CertifiedPlantType,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface DeleteAllDevicesInCertifiedPlantInput {
  plantId: string;
}
const build = (_query: DocumentNode, input: DeleteAllDevicesInCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    deleteAllDevicesInCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class DeleteAllDevicesInCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: DeleteAllDevicesInCertifiedPlantInput): Promise<apollo.FetchResult< { deleteAllDevicesInCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ deleteAllDevicesInCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
